import { Controller } from "@hotwired/stimulus"

// The preview container is resolved through the Stimulus target, never through a
// document wide lookup: several uploaders may share the same page (logo + stamp
// on the account page, signature + logo modals on the agreements dashboard).
export default class extends Controller {
  static targets = ["input", "preview"]

  preview(event) {
    const input = event.target

    if (!this.hasPreviewTarget || !input.files || !input.files[0]) return

    const file = input.files[0]

    if (file.type === 'application/pdf') {
      this.previewTarget.innerHTML = '<p class="fr-text--sm fr-mb-0">Aperçu non disponible pour les fichiers PDF</p>'
      return
    }

    const reader = new FileReader()

    reader.onload = (e) => {
      this.previewTarget.innerHTML = `<img src="${e.target.result}" alt="Aperçu du fichier" class="img-fluid" style="max-height: 192px;">`
    }

    reader.readAsDataURL(file)
  }

  clear(event) {
    event.preventDefault()

    if (this.hasInputTarget) this.inputTarget.value = ''
    if (this.hasPreviewTarget) this.previewTarget.innerHTML = ''
  }
}
